<div
  class="overview-metric"
  [ngClass]="type"
  [ngSwitch]="label === null && data === null"
>
  <app-icon
    *ngSwitchCase="true"
    class="overmetric-loading-icon"
    [icon]="largeLoadingIcon"
  >
  </app-icon>

  <ng-container *ngSwitchDefault>
    <div
      class="header"
      [ngClass]="{ 'data-loading': label === null }"
      [ngSwitch]="label === null"
    >
      <app-icon *ngSwitchCase="true" [icon]="smallLoadingIcon"> </app-icon>

      <ng-container *ngSwitchDefault>
        {{ label }}
      </ng-container>
    </div>

    <div
      class="data"
      [ngClass]="{ 'data-loading': data === null }"
      [ngSwitch]="data === null"
    >
      <app-icon *ngSwitchCase="true" [icon]="mediumLoadingIcon"> </app-icon>

      <ng-container *ngSwitchDefault>
        {{ data }}
      </ng-container>
    </div>
  </ng-container>

  <i2g-router-link
    *ngIf="cta"
    class="cta"
    buttonStyle="tertiary"
    [label]="cta.label | translate"
    [route]="cta.route"
    [icon]="cta.icon"
    [navigationExtras]="cta.navigationExtras"
    [disabled]="cta.disabled"
    i2gTrackable
    [trackingObject]="trackingObject"
    [trackingAction]="trackingAction"
  >
  </i2g-router-link>
</div>
